// extracted by mini-css-extract-plugin
module.exports = {"cardHeaderTitle":"EventInfoHeader_cardHeaderTitle__yuQZX","isMobile":"EventInfoHeader_isMobile__1fy9A"};